var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center justify-center w-10 h-10 md:w-8 md:h-8 rounded-full",class:[
    _vm.disabled ? ' text-gray-500 cursor-default' : 'hover:bg-gray-100 hover:text-gray-900',
    _vm.currentPage ? 'bg-orange-700 text-white' : ''
  ],attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }